module.exports = __webpack_public_path__ + "static/media/logo_sellanizer-weiss-ohne-sub.5d3d7753.svg";